// InputRadioForm.tsx
import React, { useEffect } from 'react';
import {
    Grid,
    styled,
    Typography,
    FormControlLabel,
    Checkbox,
    colors,
} from "@mui/material";
import { Controller, Control, FieldError, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { Balcony, TransgenderRounded } from '@mui/icons-material';

// Reusing styled components for consistency
const DescGrid = styled(Grid)(({ theme }) => ({
    padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
    paddingLeft: "10%",
}));

const CheckBoxLabel = styled(Checkbox)(({ theme }) => ({
    paddingLeft: "15%",
    color: "black",
    textAlign: "justify"
}));

interface InputCheckboxFormProps {
    name: string;
    control: Control<any>;
    label: string;
    checkboxLabel: string;
    error?: FieldError | undefined;
    targetFieldName: string;  // The name of the field to clear or modify
    setValue: UseFormSetValue<any>;  // Function to set form values
    trigger?: UseFormTrigger<any>;
}

const InputCheckboxForm: React.FC<InputCheckboxFormProps> = ({
    name,
    control,
    label,
    checkboxLabel,
    error,
    targetFieldName,
    setValue,
    trigger,
}) => {
    return (
        <Grid container>
            <DescGrid container>
                <Grid container>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field: { value: checkboxValue = false, onChange } }) => (
                            <FormControlLabel
                                control={
                                    <CheckBoxLabel
                                        name={name}
                                        checked={!!checkboxValue}
                                        onChange={(e) => {
                                            console.log("Clearing " + targetFieldName)
                                            const checked = e.target.checked;
                                            onChange(checked);
                                            if (checked) {
                                                setValue(targetFieldName, "", { shouldValidate: true });
                                            }
                                            if (trigger) {
                                                trigger(targetFieldName);
                                            }

                                        }}
                                        color="primary"
                                    />
                                }
                                label={checkboxLabel}
                                sx={{ color: 'black', width: '80%' }}
                            />
                        )}
                    />
                </Grid>
            </DescGrid>
        </Grid>
    );
};

export default InputCheckboxForm;
